module.exports = __webpack_public_path__ + "static/img/introduceBTypeBIcon6.d8532b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/introduceBTypeBIcon6.png
// module id = bBQx
// module chunks = 0